import React from "react";

const BusinessOpportunityCard = ({ language }) => {
  const content = {
    en: {
      title: "UK Business Opportunity",
      text: "Press the button and sign up to become a brand affiliate",
      button: "Become a Brand Affiliate",
    },
    ar: {
      title: "فرصة عمل في المملكة المتحدة",
      text: "اضغط على الزر للتسجيل والانضمام كمسوق للعلامة التجارية",
      button: "انضم كمسوق معتمد",
    },
  };

  const { title, text, button } = content[language || "en"];

  return (
    <div
      className="opportunity-card"
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <div className="opportunity-image">
        <img src="/assets/images/Business/Business-4.jpg" alt="Opportunity" />
      </div>
      <div className="opportunity-content">
        <h4>{title}</h4>
        <p>{text}</p>
        <button className="cta-btn" onClick={()=>window.location.href="https://nskn.co/ANxV5A"}>{button}</button>
      </div>
    </div>
  );
};

export default BusinessOpportunityCard;
